const Admin = '777cfd20-2970-4b24-a771-9beef2022729'
const Director = '4ebc8214-d137-466c-a7a9-a4e79f267d4a'
const Senior = '11f387a8-a665-4f67-ad8d-9e1a7bb51408'
const Cadet = '3e0af407-b89d-4627-beb0-716a91a5034d'
const ExecAssistant = '4514fac2-c42c-4dbe-9639-3297d0c3fba1'

const am = (permission: string | null) => {
	switch (permission) {
		case Admin:
			return 'Admin'
		case Director:
			return 'Director'
		case Senior:
			return 'Senior'
		case Cadet:
			return 'Cadet'
		case ExecAssistant:
			return 'EA'
	}
	return 'EA'
}

const have = (role: 'admin' | 'director' | 'senior' | 'cadet' | 'ea', permissionID: string | null) => {
	return (
		(role === 'admin' && permissionID === Admin) ||
		(role === 'director' && permissionID === Director) ||
		(role === 'senior' && permissionID === Senior) ||
		(role === 'cadet' && permissionID === Cadet) ||
		(role === 'ea' && permissionID === ExecAssistant)
	)
}

const haveAtLeast = (role: 'admin' | 'director' | 'senior' | 'cadet' | 'ea', permissionID: string | null) => {
	return (
		(role === 'admin' && permissionID === Admin) ||
		(role === 'director' && (permissionID === Director || permissionID === Admin)) ||
		(role === 'senior' && (permissionID === Senior || permissionID === Director || permissionID === Admin)) ||
		(role === 'cadet' && (permissionID === Cadet || permissionID === Senior || permissionID === Director || permissionID === Admin)) ||
		role === 'ea'
	)
}

export { am, have, haveAtLeast, Admin, Director, Senior, Cadet, ExecAssistant }
